export const THEME_OPTIONS = [
  { id: "stone", label: "岩灰" },
  { id: "moss", label: "苔庭" },
  { id: "ember", label: "余烬" },
  { id: "dawn", label: "晨雾" },
] as const;

export type ThemeId = (typeof THEME_OPTIONS)[number]["id"];

const THEME_STORAGE_KEY = "breacher.theme";
const DEFAULT_THEME: ThemeId = "stone";
const FONT_SCALE_STORAGE_KEY = "breacher.font-scale";
export const FONT_SCALE_MIN = 0.85;
export const FONT_SCALE_MAX = 2.5;
export const FONT_SCALE_STEP = 0.05;
export const DEFAULT_FONT_SCALE = 1;
const THEME_CHROME_COLORS: Record<ThemeId, string> = {
  stone: "#181a1b",
  moss: "#151a18",
  ember: "#1b1817",
  dawn: "#d8dcda",
};

export function readStoredTheme(): ThemeId {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return THEME_OPTIONS.some((theme) => theme.id === stored) ? (stored as ThemeId) : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function applyTheme(theme: ThemeId): void {
  document.documentElement.dataset.theme = theme;
  document
    .querySelector<HTMLMetaElement>('meta[name="theme-color"]')
    ?.setAttribute("content", THEME_CHROME_COLORS[theme]);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // The selected theme still applies for this page when storage is unavailable.
  }
}

function normalizeFontScale(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_FONT_SCALE;
  return Math.min(
    FONT_SCALE_MAX,
    Math.max(FONT_SCALE_MIN, Math.round(value / FONT_SCALE_STEP) * FONT_SCALE_STEP),
  );
}

export function readStoredFontScale(): number {
  try {
    const stored = localStorage.getItem(FONT_SCALE_STORAGE_KEY);
    return stored === null ? DEFAULT_FONT_SCALE : normalizeFontScale(Number(stored));
  } catch {
    return DEFAULT_FONT_SCALE;
  }
}

export function applyFontScale(scale: number): void {
  const normalized = normalizeFontScale(scale);
  document.documentElement.style.fontSize = `${16 * normalized}px`;
  try {
    localStorage.setItem(FONT_SCALE_STORAGE_KEY, String(normalized));
  } catch {
    // The selected scale still applies for this page when storage is unavailable.
  }
}
